import React, { useState } from 'react';
import styles from '../styles/panelList.module.css';

interface PanelItem {
  text: string;
}

interface PanelListTextProps {
  title: string;
  subtext: string;
  items: PanelItem[];
  isExpanded?: boolean;
}

const PanelListText: React.FC<PanelListTextProps> = ({
  title,
  subtext,
  items,
  isExpanded = false
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader} onClick={toggleExpanded}>
        <div className={styles.panelTitleSection}>
          <h3 className={styles.panelTitle}>{title}</h3>
          {subtext && <p className={styles.panelSubtext}>{subtext}</p>}
        </div>
        <button 
          className={`${styles.expandButton} ${expanded ? styles.expanded : ''}`}
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>
      
      {expanded && (
        <div className={styles.panelContent}>
          <div className={styles.textList}>
            {items.map((item, index) => (
              <div key={index} className={styles.textListItem}>
                <div className={styles.quoteIcon}>"</div>
                <p className={styles.quoteText}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PanelListText;



